// Catch only downward crossings of full-screen Banner + Product Grid images.
(() => {
  if (window.bannerProductGridScrollInstalled) return;
  window.bannerProductGridScrollInstalled = true;
  const mobile = window.matchMedia('(max-width: 767px)');
  const selector = '.banner-product-grid--full-viewport-mobile .left-banner';
  const stopped = new WeakSet();
  let previousY = window.scrollY;
  let hold = null;
  let releaseTimer;
  let lastTouchY = 0;
  let lastWheelTime = 0;

  function release() {
    clearTimeout(releaseTimer);
    hold = null;
    previousY = window.scrollY;
  }
  function pin() {
    previousY = hold;
    window.scrollTo({ top: hold, behavior: 'instant' });
  }
  window.addEventListener('scroll', () => {
    const y = window.scrollY;
    if (!mobile.matches) { release(); return; }
    if (hold !== null) {
      if (Math.abs(y - hold) > 1) pin();
      return;
    }
    const from = previousY;
    previousY = y;
    for (const banner of document.querySelectorAll(selector)) {
      const rect = banner.getBoundingClientRect();
      if (!rect.height) continue;
      const top = rect.top + y;
      if (y < from) {
        if (rect.top > 80) stopped.delete(banner);
        continue;
      }
      if (stopped.has(banner) || from >= top || y < top) continue;
      stopped.add(banner);
      hold = top;
      pin();
      clearTimeout(releaseTimer);
      releaseTimer = setTimeout(release, 500);
      break;
    }
  }, { passive: true });

  window.addEventListener('touchstart', event => {
    release();
    lastTouchY = event.touches[0].clientY;
  }, { passive: true });
  window.addEventListener('touchmove', event => {
    const y = event.touches[0].clientY;
    const upwardScroll = y > lastTouchY;
    lastTouchY = y;
    if (hold === null) return;
    if (upwardScroll || event.touches.length !== 1) { release(); return; }
    if (event.cancelable) event.preventDefault();
    clearTimeout(releaseTimer);
    releaseTimer = setTimeout(release, 500);
  }, { passive: false });
  window.addEventListener('wheel', event => {
    const now = Date.now();
    if (event.deltaY < 0 || now - lastWheelTime > 200) release();
    lastWheelTime = now;
    if (hold !== null && event.cancelable) event.preventDefault();
  }, { passive: false });
  window.addEventListener('keydown', release);
  window.addEventListener('resize', release);
})();
